import { relativeTime } from '../format';

import type { MessageItem } from '../../../lib/types';

/**
 * SystemEventCard — eventos sistêmicos inline no histórico
 * (delegação, retomada, transição de playbook, atribuição,
 * encerramento, reabertura, transferência).
 *
 * Renderizado quando `Message.origin === 'system'`. Visual neutro,
 * centralizado, sem bolha; texto curto. Detalhes em audit log.
 */
/**
 * Acima disto o conteúdo é FRASE (ao cliente), não rótulo de evento. Medido na
 * noturna 04/Set/2026 (A-34): a resposta de escalação do engine chega com
 * `origin: 'system'` e tem ~200 chars; rótulos («Conversa atribuída a X») ficam
 * abaixo de 60. Frase em caixa alta itálica lê-se como grito.
 */
const SENTENCE_MIN_CHARS = 60;

export function SystemEventCard({ message }: { message: MessageItem }): JSX.Element {
  const isSentence = message.content.trim().length >= SENTENCE_MIN_CHARS;
  const emphasis = isSentence
    ? 'text-xs text-text-primary'
    : 'text-2xs uppercase tracking-wide italic text-text-secondary';
  return (
    <div className="flex justify-center my-3" role="note">
      <div
        className={`${emphasis} px-3 py-1 rounded-full bg-surface-raised border border-border-subtle`}
      >
        {message.content} · <time dateTime={message.sentAt}>{relativeTime(message.sentAt)}</time>
      </div>
    </div>
  );
}
